var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';

var Overspeed = function Overspeed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 15",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "Overspeed_a",
    d: "M788.271 270.833a.564.564 0 0 1-.25-.059l-2.283-1.122a.567.567 0 1 1 .5-1.018l1.76.865a8.69 8.69 0 0 0 .677-3.384c0-4.836-3.934-8.77-8.77-8.77-4.836 0-8.77 3.934-8.77 8.77 0 1.173.224 2.303.669 3.367l1.58-.84a.567.567 0 1 1 .533 1.003l-2.113 1.121a.569.569 0 0 1-.774-.248 9.802 9.802 0 0 1-1.03-4.403c0-5.462 4.444-9.905 9.905-9.905 5.461 0 9.905 4.443 9.905 9.905a9.802 9.802 0 0 1-1.03 4.402c-.1.2-.3.316-.509.316"
  }), React.createElement("path", {
    id: "Overspeed_b",
    d: "M787.263 265.537c-.265-3.845-3.496-6.857-7.354-6.857-3.593 0-6.594 2.54-7.254 5.892l-.03.145a7.189 7.189 0 0 0-.106 1.244c.001.343.038.793.1 1.204a.567.567 0 1 0 1.122-.17 7.513 7.513 0 0 1-.087-1.033c0-.4.04-.789.113-1.167.68-3.183 3.412-4.317 5.57-4.317 2.577 0 4.357 2.194 4.783 4.36a.566.566 0 0 0 .337.415l2.02.847a.568.568 0 0 0 .786-.563"
  }), React.createElement("path", {
    id: "Overspeed_c",
    d: "M787.247 267.185l-6.657-2.993a1.103 1.103 0 0 0-.907.053.951.951 0 0 0-.459.627c-.137.562.143 1.045.714 1.228l.024.007 7.077 1.688a.326.326 0 0 0 .382-.21.324.324 0 0 0-.174-.4"
  })), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Overspeed_a",
    transform: "translate(-770 -256)"
  }), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Overspeed_b",
    transform: "translate(-770 -256)"
  }), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Overspeed_c",
    transform: "translate(-770 -256)"
  }));
};

export default Overspeed;